import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Schema } from "./SEO";

export const FaqAccordion = ({ items, withSchema = true, variant = "dark" }) => {
  const [open, setOpen] = useState(0);
  const light = variant === "light";

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <div data-testid="faq-accordion">
      {withSchema && <Schema data={faqSchema} />}
      <ul className={`divide-y border-y ${light ? "divide-[#E1D9C5] border-[#E1D9C5]" : "divide-koning-border border-koning-border"}`}>
        {items.map((f, i) => {
          const isOpen = open === i;
          return (
            <li key={i}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                data-testid={`faq-item-${i}`}
              >
                <span className={`font-display text-lg md:text-xl transition-colors ${
                  light
                    ? (isOpen ? "text-[#8A7430]" : "text-[#1A1816] group-hover:text-[#8A7430]")
                    : (isOpen ? "text-koning-gold" : "text-white group-hover:text-koning-gold")
                }`}>
                  {f.q}
                </span>
                <span className={`mt-1.5 flex-shrink-0 ${light ? "text-[#8A7430]" : "text-koning-gold"}`}>
                  {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                </span>
              </button>
              <div
                className="overflow-hidden transition-all duration-300 ease-out"
                style={{ maxHeight: isOpen ? 600 : 0 }}
              >
                <p className={`leading-relaxed pb-6 pr-10 text-sm md:text-base ${light ? "text-[#4A453E]" : "text-koning-muted"}`}>{f.a}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
